<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="ruleForm.taskName" placeholder="请输入任务名称" />
          </el-form-item>
          <template v-for="(row,index) in ruleForm.coupon">
            <el-form-item :key="index" :label="'优惠券'+numberfilter(index+1)" :prop="'coupon.'+ index" :rules="rules.undertaker" required>
              <div class="d-flex">
                <el-select v-model="row.index" v-selectLoadMore="selectLoadMore" style="width: 200px;" placeholder="请选择优惠券" @change="(value)=>selectData(value,index)">
                  <el-option v-for="(item,index1) in allCoupon" :key="item.couponId" :label="item.couponName" :value="index1" />
                </el-select>
                <el-input v-model="row.count" placeholder="请输入数量" type="number" class="ml-20" style="width: 100px;" />
                <div class="ml-20">张</div>
                <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addUndertaker(index)" />
                <i v-show="index!==0" class="icon-jia ml-20 el-icon-remove-outline" @click="delUndertaker(index)" />
              </div>
              <div class="d-flex currentStock">当前库存：{{ queryCouponStock(row.couponId) }}</div>
            </el-form-item>
          </template>
          <el-form-item label="发放目标" prop="targetType">
            <el-radio-group v-model="ruleForm.targetType">
              <el-radio v-for="(item, index) in issuanceTarget" :key="index" :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-show="ruleForm['targetType'] == 1" label="选择标签" prop="tag">
            <div class="border">
              <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterTagNode"
                @check-change="handleTagChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-show="ruleForm['targetType'] == 2" label="选择企业" prop="mechanism">
            <div class="border">
              <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterMechanismNode"
                :check-strictly="true"
                @check-change="handleMechanismChange"
              />
            </div>
          </el-form-item>
          <el-form-item v-show="ruleForm['targetType'] == 3" label="选择用户" prop="users">
            <div class="border">
              <el-input v-model="filterAccountText" placeholder="输入关键字进行过滤" />
              <!-- <el-tree
                ref="treeAccount"
                :data="accountTreeData"
                show-checkbox
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :filter-node-method="filterUserNode"
                @check-change="handleUserChange"
              /> -->
                 <GoodStree :defaultProps="defaultProps" check-strictly  @check="checkFn" :tempText="filterAccountText"  :data="accountTreeData" style="width:400px;" />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">发放模式</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="patternForm" :model="patternForm" :rules="patternRules" label-width="100px">
          <el-form-item label="选择模式" prop="grantModel">
            <el-radio-group v-model="patternForm['grantModel']">
              <el-radio
                v-for="(item, index) in constant.task.grantModel2"
                :key="index"
                :label="item.value"
                @change="cleanGrantModelJsonDate"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 周期发放 -->
          <template v-if="patternForm['grantModel'] == 2">
            <el-form-item label="总发放次数" prop="cycleCount">
              <el-input v-model="patternForm['cycleCount']" placeholder="请输入总发放次数" />
            </el-form-item>
            <el-form-item>
              <el-radio-group v-model="patternForm.grantModelJsonType">
                <el-radio
                  v-for="(item, index) in constant.task.grantModelCycle"
                  :key="index"
                  :label="item.value"
                  @change="cleanGrantModelJsonDate"
                >{{ item.label }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 周期发放---每日发放 -->
            <template v-if="patternForm.grantModelJsonType == 'day'">
              <el-form-item prop="grantModelJsonDate">
                <el-time-picker v-model="patternForm.grantModelJsonDate" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" />
              </el-form-item>
            </template>
            <!-- 周期发放---每周发放 -->
            <template v-else-if="patternForm.grantModelJsonType == 'week'">
              <el-row>
                <el-col :span="10">
                  <el-form-item prop="grantModelJsonWeek">
                    <el-select v-model="patternForm.grantModelJsonWeek" placeholder="请选择星期">
                      <el-option v-for="item in constant.task.week" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="grantModelJsonDate" label-width="10px">
                    <el-time-picker v-model="patternForm.grantModelJsonDate" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" />
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
            <!-- 周期发放---每月发放 -->
            <template v-else-if="patternForm.grantModelJsonType == 'month'">
              <el-row>
                <el-col :span="10">
                  <el-form-item prop="monthDay">
                    <el-select v-model="patternForm.monthDay" placeholder="请选择天">
                      <el-option v-for="item in 31" :key="item" :label="item" :value="item" />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="grantModelJsonDate" label-width="10px">
                    <el-time-picker
                      v-model="patternForm.grantModelJsonDate"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择时间"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </template>
          </template>

          <!-- 定时发放 -->
          <template v-else-if="patternForm['grantModel'] == 3">
            <el-form-item label="发放时间" prop="grantModelJsonDatex">
              <el-date-picker
                v-model="patternForm.grantModelJsonDatex"
                :picker-options="pickerOptions"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间"
              />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div style="width:100%;text-align: center;">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="onSubmit(true)">确定</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import Constant from '@/utils/crmConstant.json'
import { numberfilter } from '@/utils/tool'
import Moment from 'moment'
export default {
  data() {
    // 优惠券校验
    var validateCoupon = (rule, value, callback) => {
      if (!value.couponId) {
        callback(new Error(`请选择优惠券`))
      } else if (!value.count) {
        callback(new Error(`请输入数量`))
      } else if (this.queryCouponStock(value.couponId) && Number(value.count) > this.queryCouponStock(value.couponId)) {
        callback(new Error('优惠券数量大于库存数量'))
      } else {
        callback()
      }
    }
    var validateDate = (rule, value, callback) => {
      if (Date.parse(new Date()) > Date.parse(value) || Date.parse(new Date()) === Date.parse(value)) {
        callback(new Error(`发放时间不能小于当前时间`))
      } else {
        callback()
      }
    }
    return {
      defaultProps:{
        children: 'children',
        label: 'name',
         disabled:function(data,node){
                        if(data.children&&data.children.length>0){
                            return true            
                        }else{
                            return false            
                        }
                }   
      },
      checkArr:[],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
        }
      },
      constant: Constant,
      issuanceTarget: [
        {
          label: '标签',
          value: 1
        }, {
          label: '企业',
          value: 2
        }, {
          label: '用户',
          value: 3
        }
      ], // 选择目标
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterTagText: '', // 标签过滤
      filterMechanismText: '', // 企业过滤
      filterAccountText: '', // 用户过滤
      allCoupon: [], // 所有的优惠券列表
      // 基本信息
      ruleForm: {
        taskName: '', // 任务名称
        // 优惠券
        coupon: [
          {
            couponId: '', // 优惠券
            index: '',
            couponName: '', // 优惠券的label
            count: ''// 优惠券数量
          }
        ],
        targetType: 1, // 发放目标
        tag: [], // 选择标签
        mechanism: [], // 选择企业
        users: []// 选择用户
      },
      rules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        undertaker: {
          validator: validateCoupon,
          trigger: ['blur', 'change']
        },
        targetType: [
          { required: true, message: '请选择发放目标', trigger: 'change' }
        ],
        tag: [
          { required: true, message: '请选择标签', trigger: 'change' }
        ],
        mechanism: [
          { required: true, message: '请选择企业', trigger: 'change' }
        ],
        users: [
          { required: true, message: '请选择用户', trigger: 'change' }
        ]
      },
      tagTreeData: [], // 标签树全部数据
      mechanismTreeData: [], // 企业树全部数据
      accountTreeData: [], // 用户树全部数据
      // 发放模式
      patternForm: {
        grantModel: 1, // 选择模式
        grantModelJsonType: 'day',
        // 每日每周每月的时间选择字段 共用的
        grantModelJsonDate: Moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
        grantModelJsonDatex: Moment(new Date()).format('yyyy-MM-DD HH:mm:ss'),
        grantModelJsonWeek: '',
        monthDay: '', // 月份天数1-31
        cycleCount: ''// 总发放次数
      },
      patternRules: {
        grantModel: [
          { required: true, message: '请选择模式', trigger: 'change' }
        ],
        cycleCount: [
          { required: true, message: '请输入总发放次数', trigger: 'blur' }
        ],
        grantModelJsonDate: [
          { type: 'string', required: true, message: '请选择时间', trigger: 'change' }
        ],
        grantModelJsonDatex: [
          { type: 'string', required: true, message: '请选择时间', trigger: 'change' },
          { validator: validateDate, trigger: 'change' }
        ]
      },
      isLoadCoupon: false, // 控制下拉框是否还需要加载
      pageNo: 1,
      pageSize: 10
    }
  },
  watch: {
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterAccountText(val) {
      this.$refs.treeAccount.filter(val)
    }
  },
  mounted() {
    
    this.$nextTick(() => {
      // 获取全部优惠券的方法
      this.getAllCoupon()
      // 获取全部标签的方法
      this.getAlltag()
      // 获取全部企业树的发放
      this.getBusinessTree()
      // 获取全部用户树的发放
      this.geUserTree()
    })
  },
  methods: {
        checkFn(e){
            this.checkArr=e
              this.ruleForm.users=e
    },
    numberfilter(num) {
      return numberfilter(num)
    },
    // 查询优惠券库存
    queryCouponStock(id) {
      let val = this.allCoupon.find((item) => {
        return item.couponId === id
      })
      val = val || ''
      return val.stock || 0
    },
    getAlltag() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = resp
        }
      })
    },
    // 获取全部企业树的数据
    getBusinessTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = resp
        }
      })
    },
    // 获取全部用户树的数据
    geUserTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/user',
        data: { orgType: '1,3' },
        callback: resp => {
          this.accountTreeData = resp
        }
      })
    },
    // 获取全部优惠券数据
    getAllCoupon() {
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          this.allCoupon = resp.list
          this.pageNo = this.pageNo + 1
          if ((!resp.list < 10)) {
            this.isLoadCoupon = true
          }
        }
      })
    },
    // 下拉框懒加载方法
    selectLoadMore() {
      console.log('懒加载')
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        status: 0,
        hasStock: true
      }
      if (!this.isLoadCoupon) {
        return
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (!resp.list && !resp.list.length) {
            return
          }
          if (resp.list < 10) {
            this.isLoadCoupon = false
          }
          this.allCoupon.push(...resp.list)
          this.pageNo = resp.list < 10 ? this.pageNo : this.pageNo + 1
        }
      })
    },
    /**
     * 表单添加一行优惠券
     */
    addUndertaker(index) {
      const data = {
        couponId: '',
        count: '',
        index: '',
        couponName: ''
      }
      this.ruleForm.coupon.splice(index + 1, 0, data)
    },
    /**
     * 删除一行优惠券
     */
    delUndertaker(index) {
      this.ruleForm.coupon.splice(index, 1)
    },
    filterTagNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleTagChange(data, checked, indeterminate) {
      this.ruleForm.tag = this.$refs.treeTag.getCheckedKeys()
    },
    filterMechanismNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.ruleForm.mechanism = this.$refs.treeMechanism.getCheckedKeys()
    },
    filterUserNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 选择后赋值
    handleUserChange(data, checked, indeterminate) {
      this.ruleForm.users = this.$refs.treeAccount.getCheckedKeys()
    },
    cleanGrantModelJsonDate() {
      if (this.patternForm['grantModel'] === 3) {
        const date = new Date()
        const minu = date.getMinutes()
        date.setMinutes(minu + 1)
        this.patternForm.grantModelJsonDatex = Moment(date).format('yyyy-MM-DD HH:mm:ss')
      } else {
        this.patternForm.grantModelJsonDate = Moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
      }
      this.$refs['patternForm'].validate()
    },
    // 优惠券选中的change方法
    selectData(value, index) {
      const name = this.allCoupon[value].couponName
      const id = this.allCoupon[value].couponId
      this.ruleForm.coupon[index].couponName = name
      this.ruleForm.coupon[index].couponId = id
    },
    onSubmit() {
      let ruleFormBool = false
      let patternFormBool = false
      if(this.ruleForm.users.length>0){
        this.rules.mechanism[0].required=false
      this.rules.tag[0].required=false
      }
            if(this.ruleForm.mechanism.length>0){
        this.rules.users[0].required=false
      this.rules.tag[0].required=false
      }
            if(this.ruleForm.tag.length>0){
        this.rules.mechanism[0].required=false
      this.rules.users[0].required=false
      }
      this.$refs['ruleForm'].validate(valid => {
         console.log(this.$refs['ruleForm'])
        ruleFormBool = valid
      })
      this.$refs['patternForm'].validate(valid => {
        patternFormBool = valid
      })
      console.log(ruleFormBool, patternFormBool)
      if (ruleFormBool && patternFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      // 获取所有的优惠券数据
      const couponData = this.ruleForm.coupon.map(item => {
        return {
          couponId: item.couponId,
          couponName: item.couponName,
          count: item.count
        }
      })
      // 周期发放里面的三个单选枚举 day week month，因为这里也是选择，所以也是枚举
      const issuanceOptions = {
        // 每日发放
        'day': () => {
          return {
            time: this.patternForm.grantModelJsonDate
          }
        },
        // 每周发放
        'week': () => {
          return {
            day: this.patternForm.grantModelJsonWeek,
            time: this.patternForm.grantModelJsonDate
          }
        },
        // 每月发放
        'month': () => {
          return {
            day: this.patternForm.monthDay,
            time: this.patternForm.grantModelJsonDate
          }
        }
      }
      // 选择模式的枚举
      const selectOptions = {
        // 立即发放
        1: () => {
          const data = {
            time: Moment(new Date()).format('yyyy-MM-DD HH:mm:ss')
          }
          return JSON.stringify(data)
        },
        // 周期发放
        2: () => {
          // 总发放次数
          const cycleCount = this.patternForm.cycleCount
          // 每日 每周 每月发放的选择字段
          const grantModelJsonType = this.patternForm.grantModelJsonType
          // 每日 每周 每月发放下面的时间，每周和每月是两个字段，所以又做了个枚举
          const date = issuanceOptions[grantModelJsonType]()
          const data = {
            limitCount: cycleCount, // 总发放次数
            timeType: grantModelJsonType, // 每日 每周 每月发放的选择字段
            date: date
          }
          return JSON.stringify(data)
        },
        // 定时发放
        3: () => {
          const data = {
            time: this.patternForm.grantModelJsonDatex
          }
          return JSON.stringify(data)
        }
      }
      // 选择发放目标后下面的树的枚举
      const targetOptions = {
        // 标签
        1: () => {
          // 获取所有的id 字符串 以逗号分割
          const id = this.ruleForm.tag.join(',')
          return id
        },
        // 企业
        2: () => {
          // 获取所有的id 字符串 以逗号分割
          const id = this.ruleForm.mechanism.join(',')
          return id
        },
        // 用户
        3: () => {
          // 获取所有的id 字符串 以逗号分割
          // const id = this.ruleForm.users.join(',')
          const id =this.checkArr.join(',')
          return id
        }
      }
      const data = {
        taskName: this.ruleForm.taskName, // 任务名称
        couponData: JSON.stringify(couponData), // 动态添加的优惠券数据
        sendType: this.ruleForm.targetType, // 发放目标
        sendData: targetOptions[this.ruleForm.targetType](), // 发放目标下面的树，字符串 以逗号隔开
        type: this.patternForm.grantModel, // 选择模式
        taskData: selectOptions[this.patternForm.grantModel]()// 选择完模式后下面的字段
      }
      console.log('最终的数据：', data)
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/addTask',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '发放成功',
            type: 'success',
            duration: 1500
          })

          this.$router.push({path:'ManualRelease'})
          localStorage.setItem('saveMoney',1)
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.el-checkbox__label {
    vertical-align: text-top;
  }
  .d-flex{
    display: flex;
  }
  .jc-sb{
    justify-content: space-between;
  }
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .currentStock{
    height: 20px;
    align-items: center;
  }
  .ml-20{
    margin-left: 20px;
  }
  .mt-25{
    margin-top: 25px;
  }
  .currentStock {
    height: 20px;
    align-items: center;
  }
  .icon-jia{
    font-size: 22px;
    align-items: center;
    display: flex;
  }
  .amount{
    /deep/.el-input{
      width: 70%;
      padding: 0 10px;
    }
  }
  .border {
    // border: 1px solid #EEEEEE;
    // padding: 20px;
    height: 300px;
    overflow-y: auto;
  }
  //去除input的type为number时的上下箭头

  /deep/input::-webkit-outer-spin-button,
  /deep/input::-webkit-inner-spin-button { -webkit-appearance: none; }
  /deep/input[type="number"]{ -moz-appearance: textfield; }
/deep/ .el-tree {
    padding-top: 15px;
    padding-left: 10px;
    // 不可全选样式
    // .el-tree-node {
    //     .is-leaf + .el-checkbox .el-checkbox__inner {
    //         display: inline-block;
    //             cursor: pointer;
    //     }
    //     .el-checkbox .el-checkbox__inner {
    //         // display: none;
    // //             background-color: #f5f7fa;
    // // border-color: #e4e7ed;
    // // color: #c0c4cc;
    // cursor: not-allowed;
    
    //     }
    // }
}
</style>



// WEBPACK FOOTER //
// src/views/discount/couponIssuance.vue